import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import queryString from 'query-string'
import Typography from '@mui/material/Typography';

import userAuthApi from 'api/userAuthApi';
const { authenticate, userAuth, permissions } = userAuthApi;

class Login extends React.Component {

  state = {
    redirectToReferrer: false,
    queryValues: queryString.parse(this.props.location.search)
  };


  async componentDidMount() {
    const { token, authHandler } = this.props;
    var result = false;
    
    if (token) {
      result = await this.getPortalInfo();
    }

    if(result === false) {
      result = await this.login();
    }

    authHandler(result);
  }


  getPortalInfo = async () => {
    var promise = userAuth()
    .then(result => {

      if(result === true) {
        result = permissions()
        .then(permissionResult => {
          return permissionResult;
        });
      }
      
      return result;
    })
    .catch(error => {
      //TODO: error handling
      console.log(error);
      return false;
    })

    return promise;
  }


  login = async () => {
    const { loginUrl } = this.props;

    if(!this.state.queryValues.guid) {
        if (!loginUrl || !/^https?:\/\//i.test(loginUrl)) {
          console.warn(
            'Missing or invalid REACT_APP_HON_AUTH — set it in .env.local (see .env.dev). Not redirecting to portal.'
          );
          return false;
        }

        var redirectCount = Number(localStorage.getItem('missingGuidRedirectCount')) || 0;

        if(redirectCount < 1) {
          localStorage.setItem('missingGuidRedirectCount', String(redirectCount + 1));
          window.location.replace(loginUrl);
        }

        return false;
    }

    var response = await authenticate(this.state.queryValues.guid)
    .then(async result => {
      return await this.getPortalInfo(result);
    })
    .catch(error => {
      //TODO: error handling
      console.log(error);
      return false;
    });

    return response;

  };
      

  render() {
    const { isAuthenticated } = this.props;
    const state = this.props.location?.state;
    const rawFrom = state && typeof state === 'object' ? state.from : undefined;
    const hasPath =
      rawFrom &&
      typeof rawFrom.pathname === 'string' &&
      rawFrom.pathname.length > 0 &&
      rawFrom.pathname !== '/auth';

    const redirectTo = hasPath
      ? {
          pathname: rawFrom.pathname,
          search: rawFrom.search || '',
          hash: rawFrom.hash || '',
        }
      : { pathname: '/home' };

    if (isAuthenticated === true) {
      return <Navigate to={redirectTo} replace />;
    }

    const { loginUrl } = this.props;
    const missingPortalConfig = !loginUrl || !/^https?:\/\//i.test(loginUrl);

    return (
      <div>   
        <Typography component="h1" variant="h4" align="center">
            Share of Accounts
        </Typography>      

        <br />

        <Typography component="p" align="left">
          You must log in to the HON Ready Portal to view this page.  
          If you are unable to login, please contact HON Customer Support for assistance.
        </Typography>

        {missingPortalConfig && (
          <Typography component="p" align="left" color="text.secondary" sx={{ mt: 2, fontSize: '0.875rem' }}>
            Local development: set <code>REACT_APP_HON_AUTH</code> in <code>.env.local</code> (copy from <code>env.example</code> or <code>.env.dev</code>) so the app can redirect to the real portal login instead of looping.
          </Typography>
        )}
      </div>
    )
  }
}

function LoginWithRouter(props) {
  const location = useLocation();
  return <Login {...props} location={location} />;
}

export default LoginWithRouter;
